document.addEventListener('DOMContentLoaded', function () {
    // Initialize accordions to collapsed state
    const accordionBodies = document.querySelectorAll('[id^="accordion-color-"][id$="-body-"]');
    const accordionButtons = document.querySelectorAll('[data-accordion-target]');

    // Ensure all accordion bodies are hidden initially
    accordionBodies.forEach(body => {
      if (!body.classList.contains('hidden')) {
        body.classList.add('hidden');
      }
    });

    // Ensure all accordion buttons show collapsed state
    accordionButtons.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
      const icon = button.querySelector('[data-accordion-icon]');
      if (icon && !icon.classList.contains('rotate-180')) {
        icon.classList.add('rotate-180');
      }
    });

    let options;

    if (window.innerWidth < 768) {
      options = document.querySelectorAll('.option-msite');
    } else {
      options = document.querySelectorAll('.option');
    }

    // Function to apply border-left style to initially selected option
    function setInitialBorder() {
        const initiallySelected = document.querySelector('.option.selected');
        if (initiallySelected) {
          
          if (window.innerWidth < 768) {
              // For mobile
              initiallySelected.style.borderLeft = 'none';
              initiallySelected.style.borderBottom = '5px solid var(--color-primary)';

          } else {
              // For desktop
              initiallySelected.style.borderBottom = 'none';
              initiallySelected.style.borderLeft = '5px solid var(--color-primary)';
          }

            // initiallySelected.style.borderLeft = '5px solid var(--color-primary)';
        }
    }
    // Apply border-left style to initially selected option
    setInitialBorder();

    window.addEventListener('resize', setInitialBorder);

    // Event listener for click on options
    options[0].classList.add('selected');
    options[0].classList.add('font-bold');
    options.forEach(option => {
        option.addEventListener('click', function () {
            // Remove 'selected' class from all options
            options.forEach(opt => {
                opt.classList.remove('selected');
                opt.classList.remove('font-bold'); // Remove font-bold class
            });

            // Add 'selected' class to the clicked option
            this.classList.add('selected');
            this.classList.add('font-bold');

            // Remove border style from all options
            options.forEach(opt => {
                opt.style.borderLeft = 'none';
                opt.style.borderBottom = 'none';
            });

            // Remove border-left style from all options
            options.forEach(opt => opt.style.borderLeft = '');

              // Apply border style to the selected option based on screen width
            if (window.innerWidth < 768) {
                  this.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
                // For mobile
                this.style.borderLeft = 'none';
                this.style.borderBottom = '5px solid var(--color-primary)';
            } else {
                // For desktop
                this.style.borderBottom = 'none';
                this.style.borderLeft = '5px solid var(--color-primary)';
            }

            this.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });

        });
    });
});